import t from "babel-plugin-yate/macro";
import get from "lodash-es/get";
import { filteredLendingTypes } from "../../config/lendingTypes";
import { makeApiCall } from "../../lib/api/helpers";
import {
  getUserApi,
  resetPasswordApi,
  changePasswordApi,
  getNotificationsApi,
  markNotificationsApi,
  loginBrokeAgentApi,
} from "../../lib/api";
import { deleteCookie, getCookie, setCookie } from "../../lib/cookieHelper";

export const LOG_IN = "auth/LOG_IN";
export const LOG_OUT = "auth/LOG_OUT";
export const GET_USER = "auth/GET_USER";
export const RESET_PASSWORD = "auth/RESET_PASSWORD";
export const CHANGE_PASSWORD = "auth/CHANGE_PASSWORD";
export const CHANGE_LOCATION = "auth/CHANGE_LOCATION";
export const GET_NOTIFICATIONS = "auth/GET_NOTIFICATIONS";
export const MARK_NOTIFICATIONS = "auth/MARK_NOTIFICATIONS";

export const getUser = () => async (dispatch, getState) => {
  return makeApiCall({
    action: GET_USER,
    dispatch,
    getState,
    spinner: true,
    spinnerMessage: t`Loading`,
    apiCall: getUserApi,
    returnResponse: false,
    formatResponse: (response) => {
      const userIsDefaultLocationSet = localStorage.getItem(
        "userIsDefaultLocationSet",
      );

      let defaultUserLocation = "";

      const userLocationPreference = get(
        response,
        "data.data.default_location.id",
        "0",
      );

      const locations = get(response, "data.data.locations", []);

      // TODO: DRY, improve logic
      if (userIsDefaultLocationSet) {
        const storageStoredLocationId = localStorage.getItem(
          "userDefaultLocationId",
        );

        if (storageStoredLocationId !== "0") {
          defaultUserLocation =
            userLocationPreference === "0" && locations.length === 1
              ? locations[0].id
              : userLocationPreference;
        } else {
          defaultUserLocation = storageStoredLocationId;
        }
      } else {
        defaultUserLocation =
          userLocationPreference === "0" && locations.length === 1
            ? locations[0].id
            : userLocationPreference;

        localStorage.setItem("userDefaultLocationId", defaultUserLocation);
        localStorage.setItem("userIsDefaultLocationSet", true);
      }

      return {
        data: response.data.data,
        locationId: defaultUserLocation,
      };
    },
  });
};

export const changeLocation = (locationId) => (dispatch) => {
  localStorage.setItem("userDefaultLocationId", locationId);

  dispatch({
    type: CHANGE_LOCATION,
    payload: locationId,
  });
};

export const resetPassword = (payload) => async (dispatch, getState) => {
  return await makeApiCall({
    action: RESET_PASSWORD,
    dispatch,
    getState,
    spinner: true,
    apiCall: resetPasswordApi,
    apiArgs: [payload],
  });
};

export const changePassword = (payload) => async (dispatch, getState) => {
  return await makeApiCall({
    action: CHANGE_PASSWORD,
    dispatch,
    getState,
    spinner: true,
    apiCall: changePasswordApi,
    apiArgs: [payload],
  });
};

export const logIn = (payload) => async (dispatch, getState) => {
  const token = getCookie("userToken");

  if (token) {
    await dispatch(getUser());
  } else if (payload) {
    await makeApiCall({
      action: LOG_IN,
      dispatch,
      getState,
      spinner: true,
      spinnerMessage: t`Loading`,
      apiCall: loginBrokeAgentApi,
      apiArgs: [payload],
      returnResponse: false,
      postSuccess: async (response) => {
        setCookie("userToken", response.data.data.token);
        await dispatch(getUser());
      },
    });
  } else {
    dispatch(logOut());
  }
};

export const logOut = () => async (dispatch) => {
  deleteCookie("userToken");
  localStorage.removeItem("userDefaultLocationId");
  localStorage.removeItem("userIsDefaultLocationSet");

  dispatch({
    type: LOG_OUT,
  });
};

export const getNotifications = () => async (dispatch, getState) => {
  return await makeApiCall({
    action: GET_NOTIFICATIONS,
    dispatch,
    getState,
    alert: false,
    apiCall: getNotificationsApi,
    apiArgs: [],
    formatResponse: (response) => response.data.data,
  });
};

export const markNotifications =
  (is_read, payload) => async (dispatch, getState) =>
    await makeApiCall({
      action: MARK_NOTIFICATIONS,
      dispatch,
      getState,
      alert: false,
      apiCall: markNotificationsApi,
      apiArgs: [is_read, payload],
      formatResponse: (response) => response.data.data,
    });

const initialState = {
  user: {},
  isInitial: true,
  loggedIn: false,
  lendingTypes: filteredLendingTypes(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${GET_USER}_SUCCESS`:
      return {
        ...state,
        isInitial: false,
        loggedIn: true,
        user: action.payload.data,
        locationId: action.payload.locationId,
        lendingTypes: filteredLendingTypes(action.payload.data),
      };

    case LOG_OUT:
      return { ...state, isInitial: false, loggedIn: false, user: {} };

    case CHANGE_LOCATION:
      return { ...state, locationId: action.payload };

    default:
      return state;
  }
};
